// General constants
export const MAIN_URL = "/home";
export const CONTROL_TOWER_URL = process.env.REACT_APP_BASE_URL_CONTROL_TOWER;

export const COMPANY_NAME = "Origin Technology";

export const REQUEST_TIMEOUT = 15 * 60 * 1000; // 10 mints
export const REQUEST_TIMEOUT_REPORTS = 120 * 1000; // 2 mints
export const INVALID_TOKEN_STATUS_CODE = "820";

// Ui constants
export const DRAWER_WIDTH = 240;
export const TOAST_TIMEOUT = 4 * 1000; // 4 secs
